import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import { ReactComponent as RaitingIcon } from "../assets/navIcons/raiting.svg";
import { ReactComponent as GiftsIcon } from "../assets/navIcons/gifts.svg";
import { ReactComponent as MapIcon } from "../assets/navIcons/map.svg";
import { ReactComponent as ProfileIcon } from "../assets/navIcons/profile.svg";
import { ReactComponent as MainIcon } from "../assets/navIcons/main.svg";


const BottomNavigation = () => {
  const [active, setActive] = useState();

  const handleNavClick = (page) => {
    setActive(page);
  };

  return (
    <div className="bottom-navigation">
      <NavLink
        to="/faq"
        className={`nav-button ${active === 'home' ? 'active' : ''}`}
        onClick={() => handleNavClick('home')}
      >
        <MapIcon className='nav-icon' />
      </NavLink>
      <NavLink
        to="/gifts"
        className={`nav-button ${active === 'clock' ? 'active' : ''}`}
        onClick={() => handleNavClick('clock')}
      >
        <GiftsIcon className="nav-icon" />
      </NavLink>
      <NavLink
        to="/"
        className={`nav-button ${active === 'star' ? 'active' : ''}`}
        onClick={() => handleNavClick('star')}
      >
        <MainIcon className="nav-icon" />
      </NavLink>
      <NavLink
        to="/rating"
        className={`nav-button ${active === 'heart' ? 'active' : ''}`}
        onClick={() => handleNavClick('heart')}
      >
        <RaitingIcon className="nav-icon" />
      </NavLink>
      <NavLink
        to="/profile"
        className={`nav-button ${active === 'settings' ? 'active' : ''}`}
        onClick={() => handleNavClick('settings')}
      >
        <ProfileIcon className="nav-icon" />
      </NavLink>
    </div>
  );
};

export default BottomNavigation;
